var version = {
    "name":      "dativery",
    "buildDateCode": "20260824-135453",
    "buildDate": "Mon Aug 24 2026 13:54:53 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260824-135453",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;